import { Routes, Route } from 'react-router';
import {
  RecruitmentMainPage,
  RecruitmentDeveloperPage,
  RecruitmentDesignerPage,
  RecruitmentPassPage,
  RecruitmentThankyouPage,
} from '../pages/Recruitment/indexRecruitment';
import { isRecruitmentActive, isResultActive } from '../lib/constant';

const RecruitmentRoutes = ({ onSelect }) => {
  onSelect('RECRUITMENT');
  return (
    <Routes>
      <Route path="/" element={<RecruitmentMainPage onSelect={onSelect} />} />
      {isResultActive && (
        <Route path="/pass" element={<RecruitmentPassPage />} />
      )}
      {isRecruitmentActive && (
        <>
          <Route path="/developer" element={<RecruitmentDeveloperPage />} />
          <Route
            path="/developer/thankyou"
            element={<RecruitmentThankyouPage onSelect={onSelect} />}
          />
          <Route path="/designer" element={<RecruitmentDesignerPage />} />
          <Route
            path="/designer/thankyou"
            element={<RecruitmentThankyouPage onSelect={onSelect} />}
          />
        </>
      )}
    </Routes>
  );
};

export default RecruitmentRoutes;
